import { render, staticRenderFns } from "./CancelarVenda.vue?vue&type=template&id=58c109a0&lang=pug"
import script from "./CancelarVenda.vue?vue&type=script&lang=js"
export * from "./CancelarVenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports